import {
  AccountEnvironment,
  isValidEnvironment,
} from '@/util/is-valid-environment'
import { useRouter } from 'next/router'

export { useAccountEnvironment }

function useAccountEnvironment() {
  const router = useRouter()
  const [, env] = router.asPath.split('/')

  if (!isValidEnvironment(env)) {
    return { environment: AccountEnvironment.PROD }
  }

  return { environment: /** @type {AccountEnvironment} */ (env) }
}
